import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const loginState = () => {
    return new Promise((resolve, reject) => {
        let email = window.localStorage.getItem('email');
        let loginToken = window.localStorage.getItem('loginToken');
        let jwtToken = window.localStorage.getItem('jwtToken');

        if(email != null && loginToken != null && jwtToken != null){
            var fdd = new FormData;
            fdd.append('email', email);
            fdd.append('loginToken', loginToken);
            axios({
            method : "POST",
            url :  api_url + "/CheckLoginState",
            data : fdd,
            headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
            })
            .then(
                (response) => {
                    resolve(response.data);
                }, (error) => {
                    console.log(error); 
                    reject(error);
                }
            )
        } else {
            resolve({message: "notLoggedin"})
        }
    });
}